import { const_var, params } from "../../../redux/reducers/reducer";
import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import { isNumberInRange } from "../../../redux/reducers/utils";

export const handleTaxApicall = (state, action) => {
	let newFlag = 0;
	const_var.holdTaxArrResp = [];
	if (action.key == "add_zipcode") {
		if (state.const_var.LeadCustomerData.showZip != undefined) {
			state.const_var.LeadCustomerData.showZip = action.value;
		}
		state.params.tax_zipcode = action.value;
		if (action.value == "" || action.value.length < 4) {
			state.const_var.tax.amount = 0;
			const_var.post_data["building"].tax_amount = 0;
			const_var.UpdatedPriceData.tax_amount = 0;
			state.const_var.tax.type = state.const_var.tax.type == "amt" ? "per" : state.const_var.tax.type;
		}
		state.const_var.tax.percentage = 0;
		if (isNaN(parseInt(state.const_var.tax.amount)) == true) {
			state.const_var.tax.amount = 0;
		}
		if (state.const_var.tax.percentage == 0) {
			const_var.MoreTaxinputs = [];
			const_var.post_data.building.tax = [];
			const_var.holdTaxArrResp = [];
			cuBuilding.cP();
		}
	} else {
		state.const_var.tax.percentage = action.value.data != undefined && action.value.data.length > 0 ? action.value.data[0] : 0;
		state.const_var.tax.type = state.const_var.tax.type == "amt" ? "per" : state.const_var.tax.type;
		if (action.value.data != undefined && action.value.data.length > 0) {
			state.const_var.tax.tax_value = action.value.data[0];
		} else {
			state.const_var.tax.tax_value = 0;
			state.const_var.tax.amount = 0;
		}
		if (action.newvalue != undefined && action.newvalue != "") {
			const sortOrder = {
				county_rate: 1,
				city_rate: 2,
				local_rate: 3,
				state_rate: 4,
				surtax_rate: 5,
				special_dist_rate: 6
			};
			const taxTypesArray = Object.entries(action.newvalue).map(([key, value]) => ({ key, value }));

			// Sort the tax types array based on the sorting order
			taxTypesArray.sort((a, b) => sortOrder[a.key] - sortOrder[b.key]);

			// Create a new object with the sorted tax type names
			const sortedTaxTypes = {};
			taxTypesArray.forEach((item) => {
				sortedTaxTypes[item.key] = item.value;
			});

			let i = 0;
			Object.entries(action.newvalue)
				.sort()
				.map(([value, key]) => {
					if (key != 0) {
						if (i == 0) {
							state.const_var.tax.percentage = key;
							state.const_var.tax.tax_value = key;
							state.const_var.tax.name = const_var.taxTypeName[value];
						} else {
							const_var.MoreTaxinputs.push({ amount: 0, name: const_var.taxTypeName[value], percentage: key, type: "per" });
						}
						const_var.holdTaxArrResp?.push({ amount: 0, name: const_var.taxTypeName[value], percentage: key, type: "per", tax_value: key });
						i++;
					}
					newFlag = i + key + value + newFlag;
				});
			if (const_var.post_data?.building?.tax) {
				const_var.post_data.building.tax = const_var.holdTaxArrResp;
			}
			if (const_var.holdTaxArrResp.length == 0) {
				const_var.post_data.building.tax = [];
				const_var.MoreTaxinputs = [];
			}
		}
		if (isNaN(parseInt(state.const_var.tax.amount)) == true) {
			state.const_var.tax.amount = 0;
		}
		cuBuilding.cP();
	}
	return {
		...state,
		newColor: action + const_var.LeadCustomerData.showZip + params.tax_zipcode + const_var.tax.amount + const_var.tax.percentage + const_var.MoreTaxinputs.length + newFlag
	};
};
export const taxDepositCalculation = (state, action) => {
	if (action.index == "type") {
		if (action.key != "tax") {
			state.const_var.UpdatedPriceData[action.key] = action.value == "%" ? "per" : "amt";
			if (action.key == "down_payment_discount_type") {
				state.const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
				state.const_var.UpdatedPriceData["down_payment_discount_rate_Updated"] = 0;
			}
			if (action.key == "down_payment_type") {
				state.const_var.UpdatedPriceData["down_payment_rate"] = 0;
				state.const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
				state.const_var.UpdatedPriceData["down_payment_rate_Updated"] = 0;
				state.const_var.UpdatedPriceData["down_payment_discount_rate_Updated"] = 0;
			}
			if (action.key == "discount_type") {
				const_var.UpdatedPriceData.surcharge_amount = undefined;
				state.const_var.UpdatedPriceData["discount_rate"] = 0;
				state.const_var.UpdatedPriceData["discount_rate_updated"] = 0;
				const_var.manufacturer_discount_label = "";
				const_var.edited_manufacturer_discount_label = "";
			}
			if (action.key == "custom_insulation_down_payment_type") {
				state.const_var.UpdatedPriceData["custom_insulation_down_payment_rate"] = 0;
			}
			if (action.key == "custom_overhead_down_payment_type") {
				state.const_var.UpdatedPriceData["custom_overhead_down_payment_rate"] = 0;
			}
		} else {
			state.const_var.tax.type = action.value == "%" ? "per" : "amt";
			state.const_var.tax.percentage = 0;
			if (params.tax_zipcode !== "" && params.tax_zipcode.length > 4) {
				state.const_var.tax.percentage = state.const_var.tax.tax_value;
			}
		}
	} else if (action.index == "name") {
		if (action.key == "tax") {
			state.const_var.tax.name = action.value;
			params.globalTaxValue = action.value;
		}
	} else {
		if (action.key != "percentage") {
			if (action.key == "discounttypename") {
				let ValueValidate = /^[a-zA-Z\s]*$/;
				if (action.value !== null && ValueValidate.test(action.value)) {
					const_var.dealer_discount_label = action.value;
				} else {
					const_var.dealer_discount_label = const_var.dealer_discount_label;
				}
			}
			if (action.key == "MFdiscounttypename") {
				const_var.manufacturer_discount_label = action.value;
				const_var.edited_manufacturer_discount_label = const_var.manufacturer_discount_label;
				if (const_var.offer_applied_name == "") {
					const_var.manually_edited_mgf_lbl = true;
				} else {
					const_var.manufacturer_discount_changed = true;
				}
			}
			if (action.key == "discount_rate") {
				const_var.showAppliedButton = false;
				const_var.showActiveButton = true;
			}
			action.value = action.value.replace(/^0+/, "");
			action.value = action.value.replace(/[^\d.-]/g, "");
			action.value = action.value.replace(/\-/g, "");
			state.const_var.UpdatedPriceData[action.key] = action.value;
			state.const_var.UpdatedPriceData[action.key + "_Updated"] = action.value;
			const_var.post_data.building[action.key + "_Updated"] = action.value;

			state.const_var.UpdatedPriceData[action.key + "_updated"] = action.value;
			const_var.post_data.building[action.key + "_updated"] = action.value;

			if (action.key == "down_payment_discount_rate" && const_var.post_data.building["down_payment_rate"] == 0 && state.const_var.UpdatedPriceData["down_payment_rate"] == 0) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				state.const_var.UpdatedPriceData[action.key + "_updated"] = 0;
				state.const_var.UpdatedPriceData[action.key + "_Updated"] = 0;

				const_var.post_data.building["down_payment_discount_rate"] = 0;
				const_var.post_data.building[action.key + "_Updated"] = 0;
				const_var.post_data.building[action.key + "_updated"] = 0;
			}
			var regex = /^\d+(\.\d{0,2})?$/g;
			if (!regex.test(state.const_var.UpdatedPriceData[action.key])) {
				if (isNaN(parseFloat(state.const_var.UpdatedPriceData[action.key])) == true || state.const_var.UpdatedPriceData[action.key] == "") {
					state.const_var.UpdatedPriceData[action.key] = 0;

					if (action.key == "down_payment_rate") {
						const_var.post_data.building["down_payment_rate"] = 0;
						const_var.post_data.building[action.key + "_updated"] = 0;
						const_var.post_data.building[action.key + "_Updated"] = 0;

						state.const_var.UpdatedPriceData["down_payment_rate"] = 0;
						state.const_var.UpdatedPriceData["down_payment_rate_updated"] = 0;
						state.const_var.UpdatedPriceData["down_payment_rate_Updated"] = 0;

						const_var.post_data.building["down_payment_discount_rate"] = 0;
						const_var.post_data.building["down_payment_discount_rate_updated"] = 0;
						const_var.post_data.building["down_payment_discount_rate_Updated"] = 0;

						const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
						const_var.UpdatedPriceData["down_payment_discount_rate_updated"] = 0;
						const_var.UpdatedPriceData["down_payment_discount_rate_Updated"] = 0;
					}
				} else {
					state.const_var.UpdatedPriceData[action.key] = state.const_var.UpdatedPriceData[action.key].split(".");
					state.const_var.UpdatedPriceData[action.key] = state.const_var.UpdatedPriceData[action.key][0] + "." + state.const_var.UpdatedPriceData[action.key][1].substring(0, 2);
				}
			}

			if (action.key == "down_payment_rate" && state.const_var.UpdatedPriceData[action.key] == 0) {
				const_var.UpdatedPriceData.down_payment_total = 0;
			}
			if (action.key == "discount_rate") {
				const_var.UpdatedPriceData.surcharge_amount = undefined;
			}

			if (const_var.UpdatedPriceData.custom_insulation_down_payment_type == "per" && parseFloat(const_var.UpdatedPriceData.custom_insulation_down_payment_rate) > 100) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				const_var.post_data.building.custom_insulation_down_payment_rate = 0;
			}
			if (const_var.UpdatedPriceData.custom_overhead_down_payment_type == "per" && parseFloat(const_var.UpdatedPriceData.custom_overhead_down_payment_rate) > 100) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				const_var.post_data.building.custom_overhead_down_payment_rate = 0;
			}
			if (
				const_var.UpdatedPriceData.custom_insulation_down_payment_type == "amt" &&
				action.key == "custom_insulation_down_payment_rate" &&
				parseFloat(action.value) > parseFloat(const_var.post_data.building.custom_insulation_total_amount)
			) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				const_var.post_data.building.custom_insulation_down_payment_rate = 0;
			}
			if (
				const_var.UpdatedPriceData.custom_overhead_down_payment_type == "amt" &&
				action.key == "custom_overhead_down_payment_rate" &&
				parseFloat(action.value) > parseFloat(const_var.UpdatedPriceData.custom_overhead_total_amount)
			) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				const_var.post_data.building.custom_overhead_down_payment_rate = 0;
			}
			if (const_var.UpdatedPriceData.down_payment_type == "per" && parseFloat(const_var.UpdatedPriceData.down_payment_rate) > 100) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				const_var.post_data.building.down_payment_rate = 0;

				const_var.post_data.building["down_payment_discount_rate"] = 0;
				const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
			}
			if (
				const_var.UpdatedPriceData.down_payment_type == "amt" &&
				const_var.BuildingPriceArrar["sub_order_total"] != undefined &&
				parseFloat(const_var.UpdatedPriceData.down_payment_rate) > parseFloat(const_var.BuildingPriceArrar["sub_order_total"])
			) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				const_var.post_data.building.down_payment_rate = 0;

				const_var.post_data.building["down_payment_discount_rate"] = 0;
				const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
			}
			if (const_var.UpdatedPriceData.down_payment_discount_type == "per" && parseFloat(const_var.UpdatedPriceData.down_payment_discount_rate) > 100) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				const_var.post_data.building.down_payment_discount_rate = 0;
			}
			if (const_var.UpdatedPriceData.down_payment_discount_type == "amt" && parseFloat(const_var.UpdatedPriceData.down_payment_discount_rate) > parseFloat(const_var.UpdatedPriceData.down_payment_total)) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				const_var.post_data.building.down_payment_discount_rate = 0;
				const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
			}
			if (const_var.UpdatedPriceData.discount_type == "per" && parseFloat(const_var.UpdatedPriceData.discount_rate) > 100) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				const_var.post_data.building.discount_rate = 0;
				const_var.UpdatedPriceData.surcharge_amount = undefined;
			}
			if (const_var.UpdatedPriceData.discount_type == "amt" && parseFloat(const_var.UpdatedPriceData.discount_rate) > parseFloat(const_var.UpdatedPriceData.order_total)) {
				state.const_var.UpdatedPriceData[action.key] = 0;
				const_var.post_data.building.discount_rate = 0;
				const_var.UpdatedPriceData.surcharge_amount = undefined;
			}
			if (const_var.UpdatedPriceData.discount_type == "per" && parseFloat(const_var.UpdatedPriceData.discount_rate) == 100) {
				state.const_var.UpdatedPriceData["down_payment_rate"] = 0;
				state.const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
				const_var.post_data.building.down_payment_rate = 0;
				const_var.post_data.building.down_payment_discount_rate = 0;
				const_var.UpdatedPriceData.surcharge_amount = undefined;
			}
			if (const_var.UpdatedPriceData.discount_type == "amt" && parseFloat(const_var.UpdatedPriceData.discount_rate) == parseFloat(const_var.UpdatedPriceData.order_total)) {
				state.const_var.UpdatedPriceData["down_payment_rate"] = 0;
				state.const_var.UpdatedPriceData["down_payment_discount_rate"] = 0;
				const_var.post_data.building.down_payment_rate = 0;
				const_var.post_data.building.down_payment_discount_rate = 0;
				const_var.UpdatedPriceData.surcharge_amount = undefined;
			}
			if (isNaN(action.value)) {
				state.const_var.UpdatedPriceData[action.key] = 0;
			}
		} else {
			action.value = action.value.replace(/^0+/, "");
			action.value = action.value.replace(/[^\d.-]/g, "");
			action.value = action.value.replace(/\-/g, "");
			const_var.LeadCustomerData.taxPersentage = action.value;
			state.const_var.tax.percentage = action.value;
			var regex = /^\d+(\.\d{0,3})?$/g;
			if (!regex.test(state.const_var.tax.percentage)) {
				if (isNaN(parseFloat(state.const_var.tax.percentage)) == true || state.const_var.tax.percentage == "") {
					state.const_var.tax.percentage = 0;
					state.const_var.tax.amount = 0;
				} else {
					state.const_var.tax.percentage = state.const_var.tax.percentage.split(".");
					state.const_var.tax.percentage = state.const_var.tax.percentage[0] + "." + state.const_var.tax.percentage[1].substring(0, 3);
				}
			}

			if (isNaN(state.const_var.tax.percentage)) {
				state.const_var.tax.percentage = 0;
			}
		}
	}
	cuBuilding.cP();

	return {
		...state,
		newColor: action
	};
};
export const handleTax = (state, action) => {
	if (action.condition == "addNewTax" && action.nextVal != "") {
		state.const_var.MoreTaxinputs[action.index] = action.nextVal;
		if (action.indexName == "type") {
			state.const_var.MoreTaxinputs[action.index].type = action.value == "%" ? "per" : "amt";
			action.value = action.value == "%" ? "per" : "amt";
		} else {
			if (state.const_var.MoreTaxinputs[action.index].type == "%") {
				state.const_var.MoreTaxinputs[action.index].type = "per";
			}
			if (state.const_var.MoreTaxinputs[action.index].type == "$") {
				state.const_var.MoreTaxinputs[action.index].type = "amt";
			}
		}
		if (action.indexName != "percentage") {
			state.const_var.MoreTaxinputs[action.index][action.indexName] = action.value;
			params.globalTaxValue = action.value;
		} else {
			action.value = action.value.replace(/^0+/, "");
			action.value = action.value.replace(/[^\d.-]/g, "");
			action.value = action.value.replace(/\-/g, "");
			state.const_var.MoreTaxinputs[action.index][action.indexName] = action.value;

			var regex = /^\d+(\.\d{0,3})?$/g;
			if (!regex.test(state.const_var.MoreTaxinputs[action.index][action.indexName])) {
				if (isNaN(parseFloat(state.const_var.MoreTaxinputs[action.index][action.indexName])) == true || state.const_var.MoreTaxinputs[action.index][action.indexName] == "") {
					state.const_var.MoreTaxinputs[action.index][action.indexName] = 0;
				} else {
					state.const_var.MoreTaxinputs[action.index][action.indexName] = state.const_var.MoreTaxinputs[action.index][action.indexName].split(".");
					state.const_var.MoreTaxinputs[action.index][action.indexName] =
						state.const_var.MoreTaxinputs[action.index][action.indexName][0] + "." + state.const_var.MoreTaxinputs[action.index][action.indexName][1].substring(0, 3);
				}
			}

			if (isNaN(state.const_var.MoreTaxinputs[action.index][action.indexName])) {
				state.const_var.MoreTaxinputs[action.index][action.indexName] = 0;
			}
			if (state.const_var?.post_data?.building?.tax && state.const_var?.MoreTaxinputs?.[action.index]?.name == "") {
				let newTax = state.const_var.MoreTaxinputs[action.index];
				state.const_var.MoreTaxinputs[action.index].name = "sales_tax";
				state.const_var.post_data.building.tax.splice(action.index + 1, 0, newTax);
			}
		}
		cuBuilding.cP();
	}
	return {
		...state,
		AdditionNewComponentAdd: action.index + state.const_var.MoreTaxinputs[action.index].name + params.globalTaxValue + state.const_var.MoreTaxinputs[action.index].type + action.value + action.condition
	};
};

export const handleUpdatePaymentoption = (state, action) => {
	let newReder = action.key;
	if (action.key != undefined) {
		const_var.paymentOptionObj[params.paymentmode][action.key] = action.key == "expiry_date" ? action.event : action.event.replace(/[^a-zA-Z0-9\s]/g, "");
		newReder = action.key + params.paymentmode + action.event;
	} else {
		params.paymentmode = action.event;
		newReder = action.key + params.paymentmode + action.event;
	}
	const_var.post_data["building"].payment_mode = const_var.paymentOptionObj[params.paymentmode];
	return {
		...state,
		newColor: newReder
	};
};
export const handleDoorWindowInstallationFee = (state, action) => {
	if (const_var.entry_points.length > 0) {
		let wallCheckForEnd = false;
		let wallCheckForSide = false;
		const_var.entry_points.map((value, key) => {
			if (value.parent_array_key == "Garage" || value.parent_array_key == "Garage_Frameout") {
				let currentObjData = const_var?.newComponentArray?.[value.parent_array_key]?.[value.child_array_key]?.[value.nested_array_key]["Size"][value.name];
				if (currentObjData != undefined) {
					if (const_var.entry_wall_location[value.component_wall_name].includes("end") == true) {
						wallCheckForEnd = true;
					}
					if (const_var.entry_wall_location[value.component_wall_name].includes("side") == true) {
						wallCheckForSide = true;
					}
					if (wallCheckForEnd == true && currentObjData.installation_end_wall_fee != undefined) {
						value.installation_end_wall_fee = currentObjData.installation_end_wall_fee;
						value.installation_is_end_wall = currentObjData.installation_is_end_wall;
					}
					if (wallCheckForSide == true && currentObjData.installation_side_wall_fee != undefined) {
						value.installation_side_wall_fee = currentObjData.installation_side_wall_fee;
						value.installation_is_side_wall = currentObjData.installation_is_side_wall;
					}
				}
			}
		});
		cuBuilding.cP();
	}
	return {
		...state,
		action
	};
};
export const handleOfferPriceCalculation = (state, action) => {
	let temp = false;
	if (const_var.offerId != undefined && const_var.offerId != "") {
		temp = true;
	}
	const_var.UpdatedPriceData.discount_rate_updated = undefined;
	cuBuilding.cP(undefined, undefined, undefined, undefined, undefined, temp);
	return {
		...state,
		action
	};
};

export const handleNewDiscount = (state, action) => {
	if (params.m_s_n && action.expired != true) {
		state.discount_banner = false;
		delete const_var.stateManufacturerAcordingAPIDiscount["mfg_discount"][params.m_s_n];
		cuBuilding.cP();
		state.showDiscountExpire = false;
	} else {
		state.showDiscountExpire = true;
	}
	return {
		...state,
		action
	};
};

export const MayberrySurchargeCal = (from, building, categoryArray, commissionArray = undefined) => {
	let calPrice = 0;
	switch (from) {
		case "insulation":
			const_var.thirdPartyComponent.surcharge.insulation = {};
			let incTaxValue = 0;
			let incAdditionalValue = 0;
			let allInCategories = commissionArray?.map(function (item) {
				return item.category;
			});
			if (building?.insulation == "custom") {
				let selectedObj = categoryArray?.find(
					(item) =>
						item?.category?.includes(building?.insulation_type?.insulation_id) &&
						building?.insulation_price &&
						parseFloat(building.insulation_price) >= item?.price_from &&
						parseFloat(building.insulation_price) <= item?.price_to
				);
				if (
					building?.insulation_price &&
					parseFloat(building.insulation_price) >= selectedObj?.price_from &&
					parseFloat(building.insulation_price) <= selectedObj?.price_to &&
					selectedObj?.category?.includes(building?.insulation_type?.insulation_id) &&
					allInCategories?.includes(building.insulation_type.insulation_id)
				) {
					const_var.thirdPartyComponent.surcharge.insulation.center = {};
					const_var.thirdPartyComponent.surcharge.insulation.center[building.insulation_type.insulation_id] = {
						surchargeAmount: calPrice,
						itemPrice: parseFloat(building.insulation_price),
						name: building.insulation_type.name,
						componentCategory: building.insulation,
						insulation_id: building.insulation_type.insulation_id,
						amount: selectedObj.amount,
						amount_type: selectedObj.amount_type,
						percentage_of: selectedObj.percentage_of,
						category: selectedObj.category,
						price_from: selectedObj.price_from,
						price_to: selectedObj.price_to,
						surcharge_on_discounted_subtotal: selectedObj.surcharge_on_discounted_subtotal,
						taxable: selectedObj.taxable,
						taxableAmount: isTaxApplied(
							selectedObj,
							selectedObj.amount_type == "per" ? parseFloat(building.insulation_price) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount),
							parseFloat(building.insulation_price),
							"insulation",
							undefined,
							"taxable"
						),
						additionalAmount: isTaxApplied(
							selectedObj,
							selectedObj.amount_type == "per" ? parseFloat(building.insulation_price) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount),
							parseFloat(building.insulation_price),
							"insulation",
							undefined,
							"additional"
						)
					};
					calPrice = selectedObj.amount_type == "per" ? parseFloat(building.insulation_price) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount);
					const_var.thirdPartyComponent.surcharge.insulation.center[building.insulation_type.insulation_id].surchargeAmount = calPrice;
					incTaxValue += const_var.thirdPartyComponent.surcharge.insulation.center[building.insulation_type.insulation_id].taxableAmount;
					incAdditionalValue += const_var.thirdPartyComponent.surcharge.insulation.center[building.insulation_type.insulation_id].additionalAmount;
					if (selectedObj?.taxable) {
						const_var.thirdPartyComponent.surcharge.insulation.surchargeTaxable = selectedObj.taxable;
					}
				}
				const_var.post_data?.building?.leanto?.map((leanItem) => {
					if (!allInCategories?.includes(leanItem?.insulation_type?.insulation_id)) {
						return;
					}
					let selectedObj = categoryArray?.find(
						(item) =>
							leanItem?.insulation_type?.insulation_id &&
							item.category.includes(leanItem?.insulation_type?.insulation_id) &&
							leanItem.insulation_price &&
							parseFloat(leanItem.insulation_price) >= item?.price_from &&
							parseFloat(leanItem.insulation_price) <= item?.price_to
					);
					if (selectedObj && parseFloat(leanItem.insulation_price) >= selectedObj.price_from && parseFloat(leanItem.insulation_price) <= selectedObj.price_to) {
						let leanCalPrice = selectedObj.amount_type == "per" ? parseFloat(leanItem.insulation_price) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount);
						calPrice = calPrice + leanCalPrice;
						let addFor = "";
						if (leanItem.leanto_type == 1) {
							addFor = "left";
						}
						if (leanItem.leanto_type == 2) {
							addFor = "right";
						}
						if (leanItem.leanto_type == 3) {
							addFor = "front";
						}
						if (leanItem.leanto_type == 4) {
							addFor = "back";
						}
						const_var.thirdPartyComponent.surcharge.insulation[addFor] = {};
						const_var.thirdPartyComponent.surcharge.insulation[addFor][leanItem.insulation_type.insulation_id] = {
							surchargeAmount: leanCalPrice,
							itemPrice: parseFloat(leanItem.insulation_price),
							name: leanItem.insulation_type.name,
							componentCategory: building.insulation,
							insulation_id: leanItem.insulation_type.insulation_id,
							amount: selectedObj.amount,
							amount_type: selectedObj.amount_type,
							percentage_of: selectedObj.percentage_of,
							category: selectedObj.category,
							price_from: selectedObj.price_from,
							price_to: selectedObj.price_to,
							surcharge_on_discounted_subtotal: selectedObj.surcharge_on_discounted_subtotal,
							taxable: selectedObj.taxable,
							taxableAmount: isTaxApplied(selectedObj, leanCalPrice, parseFloat(leanItem.insulation_price), "insulation", undefined, "taxable"),
							additionalAmount: isTaxApplied(selectedObj, leanCalPrice, parseFloat(leanItem.insulation_price), "insulation", undefined, "additional")
						};
						incTaxValue += const_var.thirdPartyComponent.surcharge.insulation[addFor][leanItem.insulation_type.insulation_id].taxableAmount;
						incAdditionalValue += const_var.thirdPartyComponent.surcharge.insulation[addFor][leanItem.insulation_type.insulation_id].additionalAmount;
					}
					if (selectedObj?.taxable) {
						const_var.thirdPartyComponent.surcharge.insulation.surchargeTaxable = selectedObj.taxable;
					}
				});
			} else if (categoryArray?.length > 0 && building?.insulation_price && allInCategories?.includes(building.insulation_type.insulation_id)) {
				let selectedObj = categoryArray?.find(
					(item) =>
						item?.category?.includes(building?.insulation_type?.insulation_id) &&
						building?.insulation_price &&
						parseFloat(building.insulation_price) >= item?.price_from &&
						parseFloat(building.insulation_price) <= item?.price_to
				);
				if (
					building?.insulation_price &&
					parseFloat(building.insulation_price) >= selectedObj?.price_from &&
					parseFloat(building.insulation_price) <= selectedObj?.price_to &&
					selectedObj?.category?.includes(building?.insulation_type?.insulation_id)
				) {
					const_var.thirdPartyComponent.surcharge.insulation[building.insulation] = {};
					const_var.thirdPartyComponent.surcharge.insulation[building.insulation] = {
						surchargeAmount: selectedObj.amount_type == "per" ? parseFloat(building.insulation_price) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount),
						itemPrice: parseFloat(building.insulation_price),
						name: building.insulation_type.name,
						componentCategory: building.insulation,
						insulation_id: building.insulation_type.insulation_id,
						amount: selectedObj.amount,
						amount_type: selectedObj.amount_type,
						percentage_of: selectedObj.percentage_of,
						category: selectedObj.category,
						price_from: selectedObj.price_from,
						price_to: selectedObj.price_to,
						surcharge_on_discounted_subtotal: selectedObj.surcharge_on_discounted_subtotal,
						taxable: selectedObj.taxable,
						taxableAmount: isTaxApplied(
							selectedObj,
							selectedObj.amount_type == "per" ? parseFloat(building.insulation_price) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount),
							parseFloat(building.insulation_price),
							"insulation",
							undefined,
							"taxable"
						),
						additionalAmount: isTaxApplied(
							selectedObj,
							selectedObj.amount_type == "per" ? parseFloat(building.insulation_price) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount),
							parseFloat(building.insulation_price),
							"insulation",
							undefined,
							"additional"
						)
					};
					if (selectedObj.taxable) {
						const_var.thirdPartyComponent.surcharge.insulation.surchargeTaxable = selectedObj.taxable;
					}
					calPrice = selectedObj.amount_type == "per" ? parseFloat(building.insulation_price) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount);
					incTaxValue +=
						const_var.thirdPartyComponent?.surcharge?.insulation?.[building.insulation]?.taxableAmount || 0; /* isTaxApplied(selectedObj, calPrice, parseFloat(building.insulation_price), "insulation") */
					incAdditionalValue +=
						const_var.thirdPartyComponent?.surcharge?.insulation?.[building.insulation]?.additionalAmount || 0; /* isTaxApplied(selectedObj, calPrice, parseFloat(building.insulation_price), "insulation") */
				}
			}
			const_var.thirdPartyComponent.surcharge.insulation.totalPrice = calPrice + incTaxValue;
			const_var.thirdPartyComponent.surcharge.insulation.taxValue = incTaxValue;
			const_var.thirdPartyComponent.surcharge.insulation.insulationType = building?.insulation;
			const_var.thirdPartyComponent.surcharge.insulation.additionalValue = incAdditionalValue;
			calPrice += incTaxValue;
			break;
		case "garage_doors":
			let dollarPrice = 0;
			let taxValue = 0;
			let additionalValue = 0;
			const_var.thirdPartyComponent.surcharge.garage = {};
			const_var.thirdPartyComponent.tax.garage = {};
			const filterDoorTypes = categoryArray.length > 0 ? [...new Set(categoryArray?.flatMap((item) => item.category && Object.keys(item.category)))] : [];
			const filterSelectedDoors = building?.filter((item) => filterDoorTypes?.includes(item?.child_array_key));
			let allSubCategories = commissionArray?.reduce(function (acc, item) {
				return acc.concat(item.sub_category || []);
			}, []);
			filterSelectedDoors?.map((items) => {
				if (!allSubCategories.includes(items.nested_array_key)) {
					return;
				}
				let itemPrice = parseFloat(items.overheadDoorSum) || 0;
				let checkCommission = const_var.stateManufacturerAcordingAPIDiscount?.commissions?.[params.m_s_n]?.filter((cmItem) => {
					if (itemPrice >= cmItem.from && itemPrice <= cmItem.to && cmItem.sub_category.includes(items?.nested_array_key)) {
						return cmItem;
					}
				});
				let selectedObj = categoryArray?.find(
					(catItem) => catItem.category?.[items.child_array_key]?.includes(items.nested_array_key) && parseFloat(itemPrice) >= catItem.price_from && parseFloat(itemPrice) <= catItem.price_to
				);
				if (items && items.entry_type == "garage_door" && selectedObj && checkCommission?.length > 0) {
					const_var.thirdPartyComponent.surcharge.garage[items.child_array_key] = { ...const_var.thirdPartyComponent.surcharge.garage[items.child_array_key] };
					let existing = const_var.thirdPartyComponent.surcharge.garage[items.child_array_key][items.nested_array_key];
					if (existing) {
						existing.surchargeAmount = selectedObj.amount_type == "per" ? parseFloat(itemPrice) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount);
						existing.itemPrice += parseFloat(itemPrice);
						existing.amount = parseFloat(selectedObj.amount);
						existing.amount_type = selectedObj.amount_type;
						existing.percentage_of = selectedObj.percentage_of;
						existing.taxableAmount = isTaxApplied(
							selectedObj,
							selectedObj.amount_type == "per" ? parseFloat(itemPrice) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount),
							parseFloat(itemPrice),
							"garage",
							items.nested_array_key,
							"taxable",
							items
						);
						existing.additionalAmount = isTaxApplied(
							selectedObj,
							selectedObj.amount_type == "per" ? parseFloat(itemPrice) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount),
							parseFloat(itemPrice),
							"garage",
							items.nested_array_key,
							"additional",
							items
						);
						taxValue += existing.taxableAmount;
						additionalValue += existing.additionalAmount;
					} else {
						const_var.thirdPartyComponent.surcharge.garage[items.child_array_key][items.nested_array_key] = {
							surchargeAmount: selectedObj.amount_type == "per" ? parseFloat(itemPrice) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount),
							itemPrice: parseFloat(itemPrice),
							name: items.nested_array_key,
							componentCategory: items.child_array_key,
							door_size: items.name,
							amount: selectedObj.amount,
							amount_type: selectedObj.amount_type,
							percentage_of: selectedObj.percentage_of,
							category: selectedObj.category,
							price_from: selectedObj.price_from,
							price_to: selectedObj.price_to,
							surcharge_on_discounted_subtotal: selectedObj.surcharge_on_discounted_subtotal,
							taxable: selectedObj.taxable,
							taxableAmount: isTaxApplied(
								selectedObj,
								selectedObj.amount_type == "per" ? parseFloat(itemPrice) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount),
								parseFloat(itemPrice),
								"garage",
								items.nested_array_key,
								"taxable",
								items
							),
							additionalAmount: isTaxApplied(
								selectedObj,
								selectedObj.amount_type == "per" ? parseFloat(itemPrice) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount),
								parseFloat(itemPrice),
								"garage",
								items.nested_array_key,
								"additional",
								items
							)
						};
						taxValue += const_var.thirdPartyComponent.surcharge.garage[items.child_array_key][items.nested_array_key].taxableAmount;
						additionalValue += const_var.thirdPartyComponent.surcharge.garage[items.child_array_key][items.nested_array_key].additionalAmount;
					}
					if (selectedObj.amount_type == "amt") {
						dollarPrice += parseFloat(selectedObj.amount);
					}
					if (selectedObj.taxable) {
						const_var.thirdPartyComponent.surcharge.garage.surchargeTaxable = selectedObj.taxable;
					}
					calPrice += selectedObj.amount_type == "per" ? parseFloat(itemPrice) * parseFloat(selectedObj.amount / 100) : parseFloat(selectedObj.amount);
				}
			});
			const_var.thirdPartyComponent.surcharge.garage.totalPrice = calPrice; /* + taxValue */
			const_var.thirdPartyComponent.surcharge.garage.taxValue = taxValue;
			const_var.thirdPartyComponent.surcharge.garage.additionalValue = additionalValue;
			calPrice += taxValue;
			break;
		default:
			calPrice = 0;
			break;
	}

	return calPrice;
};
export const isTaxApplied = (selectedObj, calPrice, item_price, from, doorName = undefined, callFrom = "") => {
	let taxVal = 0;
	let taxAmount = 0;
	let taxArr = const_var.post_data?.building?.tax;

	if (taxArr?.length == 0 && const_var.taxDropDownValue?.length > 0 && (const_var.tax?.percentage > 0 || const_var.tax?.amount > 0)) {
		taxArr = const_var.holdTaxArrResp;
	}
	if (selectedObj?.taxable) {
		taxArr?.forEach((item) => {
			if (item.type == "per") {
				taxAmount += parseFloat(calPrice * item.percentage) / 100;
			} else if (item.type) {
				taxAmount = parseFloat(item.percentage);
			}
		});
	}
	if (selectedObj) {
		if (selectedObj?.taxable && callFrom == "taxable") {
			taxVal = /* parseFloat(taxAmount) + */ parseFloat(calPrice);
		} else if (!selectedObj?.taxable && callFrom == "additional") {
			taxVal = parseFloat(calPrice);
		}
	}
	return taxVal;
};

export const isTaxAppliedNew = (selectedObj, item_price, from, doorName = undefined, callFrom = "", item = undefined) => {
	let taxVal = 0;
	let addIn = from;
	let taxArr = const_var.post_data?.building?.tax;

	let checkTaxOrNot = from == "garage" ? const_var.thirdPartyComponent?.surcharge?.[from]?.[item.child_array_key]?.[doorName]?.taxable : callFrom == "taxable" ? 1 : 0;

	if (taxArr?.length == 0 && const_var.taxDropDownValue?.length > 0 && (const_var.tax?.percentage > 0 || const_var?.tax?.amount > 0)) {
		taxArr = const_var.holdTaxArrResp;
	}
	if (selectedObj && callFrom == "taxable") {
		taxArr?.forEach((tax, index) => {
			let name = tax.name + index;
			let total =
				from == "insulation"
					? parseFloat(const_var.thirdPartyComponent?.surcharge?.insulation?.taxValue) || 0
					: parseFloat(const_var.thirdPartyComponent?.surcharge?.[from]?.[item.child_array_key]?.[doorName]?.surchargeAmount) || 0;
			let amountBasedOnCondition = checkTaxOrNot ? parseFloat(item_price) + total : parseFloat(item_price);
			let taxExist = Object.keys(const_var.thirdPartyComponent.tax[addIn]).find((item) => item == name);
			if (taxExist) {
				if (tax.type == "per") {
					const_var.thirdPartyComponent.tax[addIn][taxExist]["tax_amount"] += tax.type == "per" ? (amountBasedOnCondition * parseFloat(tax.percentage)) / 100 : parseFloat(tax.percentage);
					taxVal += tax.type == "per" ? (amountBasedOnCondition * parseFloat(tax.percentage)) / 100 : parseFloat(tax.percentage);
				}
			} else {
				const_var.thirdPartyComponent.tax[addIn][name] = {
					name: tax.name.replace("_", " "),
					percentage: tax.percentage,
					type: tax.type,
					tax_amount: tax.type == "per" ? (amountBasedOnCondition * parseFloat(tax.percentage)) / 100 : parseFloat(tax.percentage)
				};
				if (tax.type) {
					taxVal += const_var.thirdPartyComponent.tax[addIn][name]["tax_amount"];
				}
			}
		});
	}
	return taxVal;
};

export const MayberryCommissionCal = (from, building, categoryArray) => {
	let calPrice = 0;
	switch (from) {
		case "insulation":
			const_var.thirdPartyComponent.commissions.insulation = {};
			const_var.thirdPartyComponent.tax.insulation = {};
			let incTotalValue = 0;
			let incTaxValue = 0;
			let incArray = [];
			let incAdditionalValue = 0;
			if (building?.insulation == "custom") {
				let selectedObj = categoryArray?.find(
					(item) =>
						item.category == building?.insulation_type?.insulation_id &&
						building?.insulation_price &&
						parseFloat(building.insulation_price) >= parseFloat(item?.from) &&
						parseFloat(building.insulation_price) <= parseFloat(item?.to) &&
						building.insulation_type
				);
				if (selectedObj == undefined) {
					if (const_var.thirdPartyPricesObj.insulation == undefined) {
						const_var.thirdPartyPricesObj.insulation = {};
					}
					const_var.thirdPartyPricesObj.insulation["inc_commission_amount"] = 0;
					const_var.thirdPartyPricesObj.insulation["inc_total_val"] = 0;
					const_var.thirdPartyPricesObj.insulation["inc_surcharge_val"] = 0;
					const_var.thirdPartyPricesObj.insulation["inc_subtotal"] = 0;
					const_var.thirdPartyPricesObj.insulation["inc_due_amount"] = 0;
				}
				if (
					selectedObj &&
					building?.insulation_price &&
					parseFloat(building.insulation_price) >= parseFloat(selectedObj?.from) &&
					parseFloat(building.insulation_price) <= parseFloat(selectedObj?.to) &&
					building.insulation_type
				) {
					const_var.thirdPartyComponent.commissions.insulation.center = {};

					const_var.thirdPartyComponent.commissions.insulation.center[building.insulation_type.insulation_id] = {
						commissionAmount: calPrice,
						itemPrice: parseFloat(building.insulation_price),
						name: building.insulation_type.name,
						componentCategory: building.insulation,
						insulation_id: building.insulation_type.insulation_id,
						percentage: selectedObj.percentage,
						component: selectedObj.component,
						category: selectedObj.category,
						price_from: selectedObj.from,
						price_to: selectedObj.to,
						surcharge_on_discounted_subtotal: selectedObj.surcharge_on_discounted_subtotal,
						taxable: selectedObj.taxable,
						taxableAmount: params.tax_exempt != true ? isTaxAppliedNew(selectedObj, parseFloat(building.insulation_price), "insulation", undefined, "taxable", undefined) : 0,
						additionalAmount: isTaxAppliedNew(selectedObj, parseFloat(building.insulation_price), "insulation", undefined, "additional", undefined)
					};
					incArray.push(building.insulation_type.name);
					let surcharge = const_var.thirdPartyComponent.surcharge?.insulation?.center?.[building.insulation_type.insulation_id]?.taxable
						? const_var.thirdPartyComponent.surcharge?.insulation?.center?.[building.insulation_type.insulation_id]?.taxableAmount
						: 0;
					calPrice += (parseFloat(building.insulation_price) + parseFloat(surcharge)) * parseFloat(selectedObj.percentage / 100);
					const_var.thirdPartyComponent.commissions.insulation.center[building.insulation_type.insulation_id].commissionAmount = calPrice;
					incTotalValue += const_var.thirdPartyComponent.commissions.insulation.center[building.insulation_type.insulation_id].itemPrice;
					incTaxValue += const_var.thirdPartyComponent.commissions.insulation.center[building.insulation_type.insulation_id].taxableAmount;
					incAdditionalValue += const_var.thirdPartyComponent.commissions.insulation.center[building.insulation_type.insulation_id].additionalAmount;
				}
				const_var.post_data?.building?.leanto?.map((leanItem) => {
					let selectedObj = categoryArray?.find(
						(item) =>
							leanItem?.insulation_type?.insulation_id &&
							item.category == leanItem?.insulation_type?.insulation_id &&
							leanItem.insulation_price &&
							parseFloat(leanItem.insulation_price) >= parseFloat(item?.from) &&
							parseFloat(leanItem?.insulation_price) <= parseFloat(item?.to) &&
							leanItem?.insulation_type
					);
					if (selectedObj && parseFloat(leanItem.insulation_price) >= selectedObj.from && parseFloat(leanItem.insulation_price) <= selectedObj.to && leanItem?.insulation_type) {
						let addFor = "";
						if (leanItem.leanto_type == 1) {
							addFor = "left";
						}
						if (leanItem.leanto_type == 2) {
							addFor = "right";
						}
						if (leanItem.leanto_type == 3) {
							addFor = "front";
						}
						if (leanItem.leanto_type == 4) {
							addFor = "back";
						}
						let surcharge = const_var.thirdPartyComponent.surcharge?.insulation?.[addFor]?.[leanItem.insulation_type.insulation_id]?.taxable
							? const_var.thirdPartyComponent.surcharge?.insulation?.[addFor]?.[leanItem.insulation_type.insulation_id]?.taxableAmount
							: 0;
						let leanCalPrice = (parseFloat(leanItem.insulation_price) + parseFloat(surcharge)) * parseFloat(selectedObj.percentage / 100);
						calPrice += leanCalPrice;
						const_var.thirdPartyComponent.commissions.insulation[addFor] = {};
						const_var.thirdPartyComponent.commissions.insulation[addFor][leanItem.insulation_type.insulation_id] = {
							commissionAmount: leanCalPrice,
							itemPrice: parseFloat(leanItem.insulation_price),
							name: leanItem.insulation_type.name,
							componentCategory: building.insulation,
							insulation_id: leanItem.insulation_type.insulation_id,
							percentage: selectedObj.percentage,
							component: selectedObj.component,
							category: selectedObj.category,
							price_from: selectedObj.from,
							price_to: selectedObj.to,
							taxableAmount: params.tax_exempt != true ? isTaxAppliedNew(selectedObj, parseFloat(leanItem.insulation_price), "insulation", undefined, "taxable", undefined) : 0,
							additionalAmount: isTaxAppliedNew(selectedObj, parseFloat(building.insulation_price), "insulation", undefined, "additional", undefined)
						};
						incArray.push(leanItem.insulation_type.name);
						incTotalValue += const_var.thirdPartyComponent.commissions.insulation[addFor][leanItem.insulation_type.insulation_id].itemPrice;
						incTaxValue += const_var.thirdPartyComponent.commissions.insulation[addFor][leanItem.insulation_type.insulation_id].taxableAmount;
						incAdditionalValue += const_var.thirdPartyComponent.commissions.insulation[addFor][leanItem.insulation_type.insulation_id].additionalAmount;
					}
				});
			} else if (categoryArray?.length > 0 && building?.insulation_price) {
				let selectedObj = categoryArray?.find(
					(item) =>
						item.category == building?.insulation_type?.insulation_id &&
						building?.insulation_price &&
						parseFloat(building.insulation_price) >= parseFloat(item?.from) &&
						parseFloat(building.insulation_price) <= parseFloat(item?.to) &&
						building.insulation_type
				);
				if (selectedObj && building?.insulation_price && parseFloat(building.insulation_price) >= selectedObj?.from && parseFloat(building.insulation_price) <= selectedObj?.to) {
					const_var.thirdPartyComponent.commissions.insulation[building.insulation] = {
						commissionAmount: parseFloat(building.insulation_price) * parseFloat(selectedObj.percentage / 100),
						itemPrice: parseFloat(building.insulation_price),
						name: building.insulation_type.name,
						componentCategory: building.insulation,
						insulation_id: building.insulation_type.insulation_id,
						percentage: selectedObj.percentage,
						component: selectedObj.component,
						category: selectedObj.category,
						price_from: selectedObj.from,
						price_to: selectedObj.to,
						taxableAmount: params.tax_exempt != true ? isTaxAppliedNew(selectedObj, parseFloat(building.insulation_price), "insulation", undefined, "taxable", undefined) : 0,
						additionalAmount: isTaxAppliedNew(selectedObj, parseFloat(building.insulation_price), "insulation", undefined, "additional", undefined)
					};
					let surcharge = const_var.thirdPartyComponent.surcharge.insulation[building.insulation]?.taxable ? const_var.thirdPartyComponent.surcharge.insulation[building.insulation]?.taxableAmount || 0 : 0;
					calPrice = (parseFloat(building.insulation_price) + parseFloat(surcharge)) * parseFloat(selectedObj.percentage / 100);
					incTotalValue += parseFloat(building.insulation_price);
					incTaxValue += const_var.thirdPartyComponent.commissions.insulation[building.insulation].taxableAmount; // isTaxAppliedNew(selectedObj, parseFloat(building.insulation_price), "insulation")
					incAdditionalValue += const_var.thirdPartyComponent.commissions.insulation[building.insulation].additionalAmount;
				}
				incArray.push(building.insulation_type.name);
			}
			const_var.thirdPartyComponent.commissions.insulation.totalPrice = calPrice;
			const_var.thirdPartyComponent.commissions.insulation.incTotalValue = incTotalValue;
			const_var.thirdPartyComponent.commissions.insulation.taxValue = incTaxValue;
			const_var.thirdPartyComponent.commissions.insulation.insulationType = building?.insulation;
			const_var.thirdPartyComponent.commissions.insulation.incArrayCategory = incArray;
			const_var.thirdPartyComponent.commissions.insulation.additionalValue = incAdditionalValue;
			calPrice = const_var.thirdPartyComponent.commissions.insulation.incTotalValue;
			break;
		case "garage_doors":
			let allDoorPrices = 0;
			let taxValue = 0;
			let additionalValue = 0;
			let doorsArray = [];
			const_var.thirdPartyComponent.commissions.garage = {};

			const_var.thirdPartyComponent.tax.garage = {};
			const filterDoorTypes = categoryArray?.map((item) => item.category);
			const filterSelectedDoors = building?.filter((item) => filterDoorTypes?.includes(item?.child_array_key));
			if (filterSelectedDoors == undefined) {
				const_var.thirdPartyPricesObj.garage["garage_commission_amount"] = 0;
				const_var.thirdPartyPricesObj.garage["garage_total_val"] = 0;
				const_var.thirdPartyPricesObj.garage["garage_surcharge_val"] = 0;
				const_var.thirdPartyPricesObj.garage["garage_subtotal"] = 0;
				const_var.thirdPartyPricesObj.garage["garage_due_amount"] = 0;
				const_var.thirdPartyPricesObj.garage["garage_tax_val"] = 0;
				const_var.thirdPartyPricesObj.garage["garage_add_val"] = 0;
			}
			filterSelectedDoors?.map((items) => {
				let itemPrice = parseFloat(items.overheadDoorSum) || 0;
				let selectedObj = categoryArray?.find(
					(catItem) =>
						items.child_array_key == catItem.category &&
						catItem.sub_category.includes(items.nested_array_key) &&
						parseFloat(itemPrice) >= parseFloat(catItem.from) &&
						parseFloat(itemPrice) <= parseFloat(catItem.to)
				);
				if (items && items.entry_type == "garage_door" && selectedObj) {
					const_var.thirdPartyComponent.commissions.garage[items.child_array_key] = { ...const_var.thirdPartyComponent.commissions.garage[items.child_array_key] };
					let existing = const_var.thirdPartyComponent.commissions.garage[items.child_array_key][items.nested_array_key];
					if (existing) {
						existing.itemPrice += parseFloat(itemPrice);
						existing.percentage = selectedObj.percentage;
						existing.commissionAmount += parseFloat(itemPrice) * parseFloat(selectedObj.percentage / 100);
						allDoorPrices += parseFloat(itemPrice);
						existing.taxableAmount += params.tax_exempt != true ? isTaxAppliedNew(selectedObj, parseFloat(itemPrice), "garage", items.nested_array_key, "taxable", items) : 0;
						existing.additionalAmount += isTaxAppliedNew(selectedObj, parseFloat(itemPrice), "garage", items.nested_array_key, "additional", items);
						taxValue = existing.taxableAmount;
						additionalValue = existing.additionalAmount;
						let surcharge = 0;
						if (const_var.thirdPartyComponent.surcharge?.garage?.[items.child_array_key]?.[items.nested_array_key]?.taxable) {
							surcharge = parseFloat(itemPrice) * parseFloat(const_var.thirdPartyComponent.surcharge?.garage?.[items.child_array_key]?.[items.nested_array_key]?.amount / 100);
							const_var.thirdPartyComponent.commissions.garage[items.child_array_key][items.nested_array_key]["surchargeValue"] += surcharge;
						}
						calPrice += (parseFloat(itemPrice) + parseFloat(surcharge)) * parseFloat(selectedObj.percentage / 100);
					} else {
						const_var.thirdPartyComponent.commissions.garage[items.child_array_key][items.nested_array_key] = {
							commissionAmount: parseFloat(itemPrice) * parseFloat(selectedObj.percentage / 100),
							name: items.nested_array_key,
							itemPrice: parseFloat(itemPrice),
							name: items.nested_array_key,
							componentCategory: items.child_array_key,
							door_size: items.name,

							percentage: selectedObj.percentage,
							category: selectedObj.category,
							sub_category: selectedObj.sub_category,
							price_from: selectedObj.from,
							price_to: selectedObj.to,
							taxableAmount: params.tax_exempt != true ? isTaxAppliedNew(selectedObj, parseFloat(itemPrice), "garage", items.nested_array_key, "taxable", items) : 0,
							additionalAmount: isTaxAppliedNew(selectedObj, parseFloat(itemPrice), "garage", items.nested_array_key, "additional", items)
						};
						doorsArray.push(selectedObj.sub_category);
						allDoorPrices += parseFloat(itemPrice);
						taxValue += const_var.thirdPartyComponent.commissions.garage[items.child_array_key][items.nested_array_key].taxableAmount;
						additionalValue += const_var.thirdPartyComponent.commissions.garage[items.child_array_key][items.nested_array_key].additionalAmount;
						let surcharge = 0;
						if (const_var.thirdPartyComponent.surcharge?.garage?.[items.child_array_key]?.[items.nested_array_key]?.taxable) {
							surcharge = parseFloat(itemPrice) * parseFloat(const_var.thirdPartyComponent.surcharge?.garage?.[items.child_array_key]?.[items.nested_array_key]?.amount / 100);
							const_var.thirdPartyComponent.commissions.garage[items.child_array_key][items.nested_array_key]["surchargeValue"] = surcharge;
						}
						calPrice += (parseFloat(itemPrice) + parseFloat(surcharge)) * parseFloat(selectedObj.percentage / 100);
					}
				}
			});
			const_var.thirdPartyComponent.commissions.garage.totalPrice = calPrice;
			const_var.thirdPartyComponent.commissions.garage.allDoorPrices = allDoorPrices;
			const_var.thirdPartyComponent.commissions.garage.taxValue = taxValue;
			const_var.thirdPartyComponent.commissions.garage.additionalValue = additionalValue;
			const_var.thirdPartyComponent.commissions.garage.doorsCategory = doorsArray;
			calPrice = allDoorPrices;
			break;
		default:
			calPrice = 0;
			break;
	}
	return calPrice;
};
export const resetFees = (val) => {
	if (const_var.stateData?.fetch_price_for?.document_fee == true) {
		const_var.order_extra_items.document_fee = val.document_fee || 0;
	}
	if (const_var.stateData?.fetch_price_for?.labor_fee == true) {
		const_var.is_edit_labour = undefined;
		const_var.is_edit_extra_labour = false;
		let laborFee = val.labor_fee;
		if (params.m_s_n == 178) {
			laborFee = isNumberInRange(const_var.setCustomRangeR_and_B[params.p_r_s].height, params.leanR_p_h, "height");
		}
		const_var.order_extra_items.labor_fee_on = val.labor_fee_on;
		const_var.order_extra_items.labor_per_type = laborFee;
		const_var.order_extra_items.extra_labour = laborFee;
	}
	if (const_var.stateData?.fetch_price_for?.order_permit_fee == true && const_var.editAPIDataByResponse?.data?.request_data?.building?.permit == "yes") {
		const_var.order_extra_items.order_permit_fee = val.order_permit_fee || 0;
		const_var.is_edit_extra_labour = false;
	}
	if (const_var.stateData?.fetch_price_for?.order_processing_fee == true) {
		const_var.order_extra_items.order_processing_fee = val.order_processing_fee || 0;
	}
	if (const_var.stateData?.fetch_price_for?.dealer_discount == true) {
		const_var.UpdatedPriceData.down_payment_discount_rate_Updated = undefined;
	}
	if (const_var.stateData?.fetch_price_for?.manufacturer_discount == true) {
		const_var.UpdatedPriceData.discount_rate_updated = undefined;
	}
	if (const_var.stateData?.fetch_price_for?.surcharge == true) {
		const_var.UpdatedPriceData.surcharge_amount = undefined;
	}
};